import { render, staticRenderFns } from "./estate-new-edit.vue?vue&type=template&id=fcd212b4&"
import script from "./estate-new-edit.vue?vue&type=script&lang=js&"
export * from "./estate-new-edit.vue?vue&type=script&lang=js&"
import style0 from "./estate-new-edit.vue?vue&type=style&index=0&id=fcd212b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports